"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _api = require("@react-google-maps/api");

var _GeopointLoader = _interopRequireDefault(require("./GeopointLoader"));

var _styles = require("@material-ui/core/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    backgroundColor: "#e5e3df",
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    width: "100%",
    height: "100%"
  }
}));

const GeopointBase = ({
  className,
  googleMapsApiKey,
  children
}) => {
  const classes = useStyles();
  return _react.default.createElement("div", {
    className: className || classes.root
  }, _react.default.createElement(_api.LoadScript, {
    libraries: ["places"],
    loadingElement: _GeopointLoader.default,
    googleMapsApiKey: googleMapsApiKey,
    preventGoogleFontsLoading: true
  }, children));
};

GeopointBase.defaultProps = {
  googleMapsApiKey: "AIzaSyA0UKwjqalA0BdK5GBh8RPR9HJjtifWLAg"
};

var _default = (0, _react.memo)(GeopointBase);

exports.default = _default;
module.exports = exports.default;